import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Events } from '../../services/events.service';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import { LoginComponent } from '../../login/login.component';

declare var title: any;

@Component({
	selector: 'app-logon',
	templateUrl: './logon.component.html',
	styleUrls: ['./logon.component.css']
})
export class LogonComponent implements OnInit {

	logi_user:any;
	logi_name:any;
	logi_level:any;

	constructor(
		private http: HttpClient,
		private router:Router,
		public dialog: MatDialog,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
		public events: Events
	) {
		this.events.subscribe('user:login', (data: any) => {
			this.getUserData();
		});

		this.events.subscribe('user:open', (data: any) => {
			this.loginOpen();
		});
	}

	ngOnInit() {
		this.getUserData();
	}

	async getUserData() {
		this.logi_user = await this.authService.getToken();
		var formData: any = new FormData();
		formData.append("logiUserid", this.logi_user);

		this.http.post(this.env.API_URL + 'api/user.data.php', formData).subscribe((response) => {
			this.logi_name = response['data']['name'];
			this.logi_level = response['data']['level'];
		});

		this.events.destroy('user:login');
	}

	loginOpen() {
		const modal = this.dialog.open(LoginComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '500px',
			data: {
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['id'] )
				{
					this.events.publish('user:login', true);
					this.getUserData();
				}
			}
		});

		this.events.destroy('user:open');
	}


	logiLogout() {
		this.authService.logout().subscribe(
			data => {
				this.func.bottomToast(data['message']);
				this.logi_name = "";
				this.logi_level = "";

				this.events.publish('user:logout', true);

				this.router.navigate(['/order']);
			},
			error => {
				console.log(error);
			},
			() => {
			}
		);
	}

}
